export default {
  install(Vue) {
    Vue.prototype.$lang = function() {
      app.$log.info("lang--------------->" + app.$store.state.lang);

      const params = {
        // natCode: app.$store.state.lang,
        setNativeLanguage: {
          ENG: {
            "MOTP-01-01-02-01": "Enter mOTP PIN ",
            "MOTP-01-01-02-02": "Enter 6-digit mOTP PIN ",
            "MOTP-01-01-02-03": "Next",
            "MOTP-01-01-03-01": "Confirm the mOTP PIN",
            "MOTP-01-01-03-02": "Enter the mOTP PIN again",
            "MOTP-01-01-03-03": "Back",
            "MOTP-01-01-03-04": "Done",
            "MOTP-CERTN-01": "mOTP Verification error has been occurred",
            "MOTP-CERTN-13": "mOTP PIN must be reset in case of 5 incorrect inputs",
            "MLGI-01-01-02-01": "EASY-PIN",
            "MLGI-01-01-02-02": "Enter EASY-PIN",
            "MLGI-02-01-07-02": "Enter the (6)-digit EASY-PIN number",
            "MLGI-02-01-07-03": "Vereification completed",
            "MLGI-05-01-03-01": "Simple Verification login",
            "MLGI-05-02-01-02": "Enter (6)-digit Simple Verification Number to use",
            "MLGI-05-02-02-01": "Changing Simple Verification Number",
            "MLGI-05-02-02-02": "Enter (6)-digit Simple Verification Number to change",
            "MLGI-05-02-03-01": "Checking Simple Verification Number",
            "MLGI-05-02-03-02": "Enter EASY-PIN Number again that you have entered before.",
            "MLGI-06-01-03-02": "Please use fingerprint for verification",
            "MLGI-06-01-04-02": "Please use Face ID for verification",
            "MLGI-05-01-05-02": "The verification number is mismatched (5) times and needs to be reset.",
            "MOTP-CERTN-22": "Verification number is incorrect",
            "MOTP-CERTN-23": "reset is mandatory in case of more than 5 incorrect inputs",
            
          },

          KHM: {
            "MOTP-01-01-02-01": "បញ្ចូល PIN mOTP",
            "MOTP-01-01-02-02": "បញ្ចូល PIN mOTP ៦ ខ្ទង់",
            "MOTP-01-01-02-03": "បន្ទាប់",
            "MOTP-01-01-03-01": "បញ្ជាក់យល់ព្រមចំពោះ PIN mOTP",
            "MOTP-01-01-03-02": "បញ្ចូល PIN mOTP ម្តងទៀត",
            "MOTP-01-01-03-03": "ត្រឡប់ក្រោយ",
            "MOTP-01-01-03-04": "រួចរាល់",
            "MOTP-CERTN-01": "មានបញ្ហាក្នុងការផ្ទៀងផ្ទាត់ mOTP។",
            "MOTP-CERTN-13": "PIN mOTP ត្រូវតែបង្កើតឡើងវិញ ក្នុងករណីបញ្ចូលមិនបានត្រឹមត្រូវចំនួន ៥ ដង",
            "MLGI-01-01-02-01": "លេខ PIN ងាយស្រួល",
            "MLGI-01-01-02-02": "បញ្ចូលលេខ PIN ងាយស្រួល",
            "MLGI-02-01-07-02": "បញ្ចូលលេខ PIN ងាយស្រួល ៦ខ្ទង់",
            "MLGI-02-01-07-03": "បញ្ចប់ការផ្ទៀងផ្ទាត់",
            "MLGI-05-01-03-01": "ឡុកអ៊ីនការផ្ទៀងផ្ទាត់ដ៏សាមញ្ញ",
            "MLGI-05-02-01-02": "បញ្ចូលលេខកូដផ្ទៀងផ្ទាត់សាមញ្ញ ៦ខ្ទង់ ដើម្បីប្រើប្រាស់",
            "MLGI-05-02-02-01": "កែប្រែលេខកូដផ្ទៀងផ្ទាត់សាមញ្ញ",
            "MLGI-05-02-02-02": "បញ្ចូលលេខកូដផ្ទៀងផ្ទាត់សាមញ្ញ ៦ខ្ទង់ ដើម្បីកែប្រែ",
            "MLGI-05-02-03-01": "ត្រួតពិនិត្យលេខកូដផ្ទៀងផ្ទាត់សាមញ្ញ",
            "MLGI-05-02-03-02": "បញ្ចូលលេខ PIN ងាយស្រួល ដែលបានបញ្ចូលមុននេះម្តងទៀត",
            "MLGI-06-01-03-02": "សូមប្រើស្នាមម្រាមដៃដើម្បីធ្វើការផ្ទៀងផ្ទាត់",
            "MLGI-06-01-04-02": "សូមប្រើ ID ផ្ទៃមុខដើម្បីធ្វើការផ្ទៀងផ្ទាត់",
            "MLGI-05-01-05-02": "The verification number is mismatched (5) times and needs to be reset.",
            "MOTP-CERTN-22": "លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវនោះទេ",
            "MOTP-CERTN-23": "ការបង្កើតឡើងវិញគឺចាំបាច់ ក្នុងករណីបញ្ចូលលេខកូដខុស 5 ដងជាប់ៗគ្នា",
          },
          KOR: {
            "MOTP-01-01-02-01": "mOTP PIN번호 입력",
            "MOTP-01-01-02-02": "mOTP PIN번호 6자리를 입력하세요",
            "MOTP-01-01-02-03": "다음",
            "MOTP-01-01-03-01": "mOTP PIN번호 입력 확인",
            "MOTP-01-01-03-02": "등록했던 mOTP PIN번호를 다시 입력해 주세요",
            "MOTP-01-01-03-03": "이전",
            "MOTP-01-01-03-04": "입력 완료",
            "MOTP-CERTN-01": "mOTP 인증번호 오류가 발생하였습니다.",
            "MOTP-CERTN-13": "연속 5회 오류시 mOTP PIN 분실 변경 필요",
            "MLGI-01-01-02-01": "간편인증번호",
            "MLGI-01-01-02-02": "간편인증번호 입력",
            "MLGI-02-01-07-02": "간편 인증 번호 6자리를 입력하세요",
            "MLGI-02-01-07-03": "인증 완료",
            "MLGI-05-01-03-01": "간편 인증 로그인",
            "MLGI-05-02-01-02": "사용하실 간편 인증 번호 6자리를 입력하세요",
            "MLGI-05-02-02-01": "간편 인증 번호 변경",
            "MLGI-05-02-02-02": "변경하실 간편 인증 번호 6자리를 입력하세요",
            "MLGI-05-02-03-01": "간편 인증 번호 확인",
            "MLGI-05-02-03-02": "앞에서 입력한 간편 인증번호를 한번 더 입력하세요",
            "MLGI-06-01-03-02": "지문 인증을 해주세요",
            "MLGI-06-01-04-02": "Face ID 인증을 해주세요.",
            "MLGI-05-01-05-02": "인증번호가 5회 불일치 되어 재설정이 필요합니다.",
            "MOTP-CERTN-22": "인증번호가 일치하지 않습니다.",
            "MOTP-CERTN-23": "오류 5회 초과시 재설정이 필요합니다.",
          },
          MMR: {
            "MOTP-01-01-02-01": "mOTP PIN နံပါတ် ထည့်သွင်းပါ",
            "MOTP-01-01-02-02": "ဂဏန်း (၆) လုံးပါ mOTP PIN ထည့်သွင်းပါ",
            "MOTP-01-01-02-03": "ရှေ့သို့",
            "MOTP-01-01-03-01": "mOTP PIN အတည်ပြုပါ",
            "MOTP-01-01-03-02": "mOTP PIN နံပါတ်ကို ထပ်မံထည့်သွင်းပါ",
            "MOTP-01-01-03-03": "ပြီးခဲ့သော",
            "MOTP-01-01-03-04": "ထည့်သွင်းခြင်း ပြီးဆုံးသည်",
            "MOTP-CERTN-01": "mOTP အတည့်ပြုခြင်းမှားယွင်းမှု ဖြစ်ပွားခဲ့ပါသည်။",
            "MOTP-CERTN-13": "mOTP PIN ကို (၅)ကြိမ်ဆက်တိုက်မှားယွင်းစွာ ထည့်သွင်းမိပါက mOTP PIN ပျောက်ဆုံး၊ ပြောင်းလဲမှု လိုအပ်ပါသည်။",
            "MLGI-01-01-02-01": "EASY-PIN",
            "MLGI-01-01-02-02": "EASY-PIN ကိုထည့်သွင်းပါ။",
            "MLGI-02-01-07-02": "EASY-PIN နံပါတ် (၆)လုံးကို ထည့်သွင်းပါ။",
            "MLGI-02-01-07-03": "အတည်ပြုခြင်း အောင်မြင်ပါသည်။",
            "MLGI-05-01-03-01": "လွယ်ကူသောအတည်ပြုခြင်း login",
            "MLGI-05-02-01-02": "လွယ်ကူသောအတည်ပြုနံပါတ်ကို အသုံးပြုရန် နံပါတ် (၆) လုံးထည်သွင်းမည်။",
            "MLGI-05-02-02-01": "လွယ်ကူသောအတည်ပြုနံပါတ် ပြောင်းလဲခြင်း",
            "MLGI-05-02-02-02": "လွယ်ကူသောအတည်ပြုနံပါတ်ကို ပြောင်းလဲရန် နံပါတ် (၆) လုံးထည်သွင်းမည်။",
            "MLGI-05-02-02-02": "ပြောင်းလဲရန် လွယ်ကူသောအတည်ပြုဂဏန်း (6)လုံးကိုထည့်ပါ",
            "MLGI-05-02-03-01": "လွယ်ကူသောအတည်ပြုနံပါတ် စစ်ဆေးခြင်း",
            "MLGI-05-02-03-02": "ယခင်က ထည့်သွင်းဖူးသော EASY-PIN နံပါတ်ကို ထပ်မံထည့်သွင်းပါ။",
            "MLGI-06-01-03-02": "အတည်ပြုခြင်းအတွက် လက်ဗွေကိုအသုံးပြုပါ။",
            "MLGI-06-01-04-02": "အတည်ပြုခြင်းအတွက် Face ID ကိုအသုံးပြုပါ။",
            "MLGI-05-01-05-02": "အတည်ပြုနံပါတ်ကို (၅) ကြိမ်ထပ်ကျော်လွန်၍ မှားယွင်းထည့်သွင်းထားသောကြောင့် ပြန်လည်သတ်မှတ်ရန်လိုပါသည်။ ",
            "MOTP-CERTN-22": "အတည်ပြုခြင်းနံပါတ် မမှန်ကန်ပါ။",
            "MOTP-CERTN-23": "၅ ကြိမ်ထပ်မှားယွင်းထည့်သွင်းပါက ပြန်လည်သတ်မှတ်ခြင်းကိုမဖြစ်မနေပြုလုပ်ရမည် ၊",
          },
          VNM: {
            "MOTP-01-01-02-01": "Nhập mã Pin mOTP ",
            "MOTP-01-01-02-02": "Nhập mã Pin mOTP 6 chữ số",
            "MOTP-01-01-02-03": "Tiếp ",
            "MOTP-01-01-03-01": "Xác nhận mã Pin mOTP ",
            "MOTP-01-01-03-02": "Nhập lại mã Pin mOTP",
            "MOTP-01-01-03-03": "Quay lại",
            "MOTP-01-01-03-04": "Hoàn tất ",
            "MOTP-CERTN-01": "Đã xảy ra lỗi xác thực mOTP",
            "MOTP-CERTN-13": "Nhập sai 5 lần liên tiếp, mã PIN mOTP sẽ bị khóa và phải thiết lập lại",
            "MLGI-01-01-02-01": "Mã EASY-PIN",
            "MLGI-01-01-02-02": "Nhập mã EASY-PIN",
            "MLGI-02-01-07-02": "Nhập mã EASY-PIN 6 số",
            "MLGI-02-01-07-03": "Xác thực hoàn tất",
            "MLGI-05-01-03-01": "Đăng nhập bằng mã xác thực ",
            "MLGI-05-02-01-02": "Nhập mã PIN 6 chữ số hiện tại",
            "MLGI-05-02-02-01": "Thay đổi mã PIN ",
            "MLGI-05-02-02-02": "Nhập mã PIN 6 chữ số mới",
            "MLGI-05-02-03-01": "Xác nhận mã PIN",
            "MLGI-05-02-03-02": "Nhập lại mã PIN vừa nhập",
            "MLGI-06-01-03-02": "Vui lòng xác thực bằng dấu vân tay ",
            "MLGI-06-01-04-02": "Vui lòng xác thực bằng Face ID  ",
            "MLGI-05-01-05-02": "Nhập sai mã xác thực 5 lần, vui lòng đăng kí lại",
            "MOTP-CERTN-22": "Verification number is incorrect",
            "MOTP-CERTN-23": "Nếu nhập sai 5 lần, cần đặt lại mật khẩu",
          },
        },
      };
      this.$bridge.setNativeData(params);
    };
  },
};
